import { useAppSelector } from '../../modules/hooks';
import { selectSeriesWatchtime } from '../../modules/watchtime';
import {
  selectIsSeriesWatchtimeFetched,
  selectIsSeriesWatchtimeFetching,
} from '../../modules/fetching';

import type { Vendor } from '../../types';
import type { SvpCategoryId } from '@vgtv/api-client/lib/svp_category';

export const useSeriesWatchtime = ({
  categoryId,
  vendor,
}: {
  categoryId: SvpCategoryId;
  vendor: Vendor;
}) => {
  const isFetching = useAppSelector((state) =>
    selectIsSeriesWatchtimeFetching(state, categoryId, vendor)
  );
  const isFetched = useAppSelector((state) =>
    selectIsSeriesWatchtimeFetched(state, categoryId, vendor)
  );
  const watchtime = useAppSelector((state) =>
    selectSeriesWatchtime(state, vendor, categoryId)
  );

  return {
    isFetching,
    isFetched,
    watchtime,
  };
};
